/* ============================================================
   Chiara & Co. — newsletter popup
   Standalone: only loaded by sections/chiara-popup.liquid

   Submits straight to Mailchimp's embedded-form endpoint via JSONP,
   so no API key ever reaches the browser and no app is required.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var dialog   = root.querySelector('.chiara-popup__dialog');
    var form     = root.querySelector('.chiara-popup__form');
    var message  = root.querySelector('.chiara-popup__message');
    var submit   = root.querySelector('.chiara-popup__submit');
    var closers  = root.querySelectorAll('[data-popup-close]');

    var section    = root.closest('[id^="shopify-section"]') || document;
    var tab        = section.querySelector('[data-popup-tab]');
    var tabDismiss = section.querySelector('[data-popup-tab-dismiss]');

    var reward     = root.querySelector('[data-popup-reward]');
    var codeBtn    = root.querySelector('[data-popup-code]');
    var copyHint   = root.querySelector('[data-popup-copy-hint]');

    var trigger    = root.dataset.trigger || 'delay';
    var scrollPct  = parseInt(root.dataset.scroll || '35', 10);
    var delay      = parseInt(root.dataset.delay || '4', 10) * 1000;
    var frequency  = parseInt(root.dataset.frequency || '7', 10);   // days
    var storageKey = 'chiara-popup:' + (root.dataset.key || 'default');
    var action     = root.dataset.action || '';
    var inEditor   = root.dataset.editor === 'true';

    /* ---------- open / close ---------- */
    function shouldShow() {
      if (inEditor) return true;
      if (frequency <= 0) return true;
      try {
        var last = window.localStorage.getItem(storageKey);
        if (!last) return true;
        var days = (Date.now() - parseInt(last, 10)) / 86400000;
        return days >= frequency;
      } catch (e) {
        return true;              // private mode: show rather than fail silently
      }
    }

    function remember() {
      try { window.localStorage.setItem(storageKey, String(Date.now())); } catch (e) {}
    }

    function open() {
      root.classList.add('is-open');
      // next frame so the transition actually runs
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { root.classList.add('is-visible'); });
      });
      document.addEventListener('keydown', onKey);
      var first = root.querySelector('.chiara-popup__field');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    }

    function close() {
      root.classList.remove('is-visible');
      document.removeEventListener('keydown', onKey);
      window.setTimeout(function () { root.classList.remove('is-open'); }, 320);
      remember();
      showTab();
    }

    function showTab() {
      if (!tab) return;
      try { if (window.localStorage.getItem(storageKey + ':tab') === 'off') return; } catch (e) {}
      tab.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { tab.classList.add('is-in'); });
      });
    }

    function hideTab(permanent) {
      if (!tab) return;
      tab.classList.remove('is-in');
      window.setTimeout(function () { tab.hidden = true; }, 320);
      if (permanent) {
        try { window.localStorage.setItem(storageKey + ':tab', 'off'); } catch (e) {}
      }
    }

    if (tab) {
      tab.addEventListener('click', function (e) {
        if (tabDismiss && tabDismiss.contains(e.target)) return;   // X handled below
        hideTab(false);
        open();
      });
    }

    if (tabDismiss) {
      tabDismiss.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        hideTab(true);
      });
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    Array.prototype.forEach.call(closers, function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });

    if (dialog) dialog.addEventListener('click', function (e) { e.stopPropagation(); });

    /* ---------- Mailchimp submit (JSONP) ---------- */
    function jsonp(url, callback) {
      var name = 'chiaraPopupCb' + Date.now() + Math.floor(Math.random() * 1000);
      var script = document.createElement('script');
      var done = false;

      window[name] = function (data) {
        done = true;
        callback(null, data);
        cleanup();
      };

      function cleanup() {
        try { delete window[name]; } catch (e) { window[name] = undefined; }
        if (script.parentNode) script.parentNode.removeChild(script);
      }

      script.onerror = function () { if (!done) { callback(new Error('network')); cleanup(); } };
      script.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'c=' + name;
      document.body.appendChild(script);

      window.setTimeout(function () {
        if (!done) { callback(new Error('timeout')); cleanup(); }
      }, 12000);
    }

    function say(text, kind) {
      if (!message) return;
      message.textContent = text;
      message.className = 'chiara-popup__message chiara-popup__message--' + kind;
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        // No Mailchimp URL configured -> let it submit normally (Shopify customer form)
        if (!action) return;

        e.preventDefault();
        var email = form.querySelector('[name="EMAIL"]');
        if (!email || !email.value.trim()) {
          say(root.dataset.msgInvalid || 'Please enter your email address.', 'error');
          return;
        }

        var params = [];
        Array.prototype.forEach.call(form.querySelectorAll('input[name]'), function (input) {
          if (!input.name) return;
          params.push(encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value));
        });

        // Chained string .replace() was a bug: after '/post?' -> '/post-json?',
        // the second replace matched inside '/post-json' and produced
        // '/post-json-json', which 404s. One anchored regex instead.
        var url = action.replace(/\/post(-json)?(\?|$)/, '/post-json$2');
        url += (url.indexOf('?') > -1 ? '&' : '?') + params.join('&');

        if (submit) { submit.disabled = true; }
        say(root.dataset.msgSending || 'Signing you up…', 'success');

        jsonp(url, function (err, data) {
          if (submit) { submit.disabled = false; }

          if (err) {
            say(root.dataset.msgError || 'Something went wrong. Please try again.', 'error');
            return;
          }

          if (data && data.result === 'success') {
            say(root.dataset.msgSuccess || 'Thank you — your code is on its way.', 'success');
            form.reset();
            remember();
            if (reward) { revealReward(); }
            else { window.setTimeout(close, 2600); }
          } else {
            // Mailchimp returns HTML in msg; strip tags and the leading error code
            var msg = (data && data.msg) ? String(data.msg).replace(/<[^>]*>/g, '') : '';
            if (/already subscribed/i.test(msg)) {
              say(root.dataset.msgAlready || 'You are already on the list.', 'success');
            } else {
              say(msg.replace(/^\d+\s*-\s*/, '') || root.dataset.msgError || 'Something went wrong.', 'error');
            }
          }
        });
      });
    }

    /* ---------- discount reward ---------- */
    function revealReward() {
      if (!reward) return;
      if (form) form.style.display = 'none';
      reward.hidden = false;
      try { window.localStorage.setItem(storageKey + ':claimed', '1'); } catch (e) {}
    }

    if (codeBtn) {
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.dataset.code || '';
        var done = function () {
          codeBtn.classList.add('is-copied');
          if (copyHint) copyHint.textContent = root.dataset.copiedLabel || 'Copied';
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
        function fallbackCopy() {
          var t = document.createElement('textarea');
          t.value = code;
          t.setAttribute('readonly', '');
          t.style.position = 'absolute';
          t.style.left = '-9999px';
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    }

    // Shopify's own form posts and reloads, so restore the reward on return
    if (reward && form && !action) {
      if (form.querySelector('.chiara-popup__message--success')) { revealReward(); }
    }

    /* ---------- triggers ---------- */
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      open();
    }

    if (inEditor) {
      open();                                   // always visible while editing
    } else if (!shouldShow() || trigger === 'click') {
      // nothing auto-opens; offer the pill so it can still be reached
      showTab();
    } else if (trigger === 'scroll') {
      var onScroll = function () {
        var doc = document.documentElement;
        var max = (doc.scrollHeight - window.innerHeight) || 1;
        if ((window.scrollY / max) * 100 >= scrollPct) {
          window.removeEventListener('scroll', onScroll);
          fire();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else if (trigger === 'exit') {
      var onLeave = function (e) {
        if (e.clientY <= 0) {
          document.removeEventListener('mouseout', onLeave);
          fire();
        }
      };
      document.addEventListener('mouseout', onLeave);
      // touch devices never fire mouseout - fall back to a long delay
      window.setTimeout(fire, Math.max(delay, 15000));
    } else {
      window.setTimeout(fire, delay);
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.chiara-popup'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.chiara-popup');
    if (el) init(el);
  });
})();
